<template>
  <div>
    <div class="vx-row">

      <div class="vx-col w-full">
        <vx-card title="CUSTOMER SITES" >
          <template slot="actions">
            <vs-button v-can="'create-edit-site'" @click="onClickCreateSite" class="mr-4" color="primary" type="filled">Create</vs-button>
          </template>
          <div slot="no-body" class="mt-4">
            <vs-input v-can="'view-site'" icon-pack="feather" icon="icon-search" placeholder="Search"
                      v-model="filters['search']"
                      class="is-label-placeholder px-3 pb-5 w-full md:w-1/3 xl:w-1/7 rounded-full" />
            <vs-table id="customer-site-list-table" v-can="'view-site'" :max-items="(meta.per_page) ? meta.per_page : 10" :data="staff"   :sst="true" stripe class="table-dark-inverted table-auto vs-con-loading__container">

              <template slot="thead">
                <vs-th sort-key="name">NAME</vs-th>
                <vs-th sort-key="site_telephone">TELEPHONE</vs-th>
                <vs-th sort-key="site_email">EMAIL</vs-th>
                <vs-th >ACTIVE STATUS</vs-th>
                <vs-th v-can="'create-edit-site'">ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr @click.native="onClickCustomerSiteUpdate(data[indextr].id)" style="cursor: pointer"  :key="indextr" v-for="(tr, indextr) in data">


                  <vs-td :data="data[indextr].name">
                    {{ data[indextr].name}}
                  </vs-td>
                  <vs-td :data="data[indextr].telephone">
                    {{ data[indextr].country_code_telephone }} {{ data[indextr].telephone }}
                  </vs-td>

                  <vs-td :data="data[indextr].email">
                    {{ data[indextr].email }}
                  </vs-td>

                  <vs-td :data="data[indextr].is_active" :class="data[indextr].is_active ? 'text-primary' : 'text-danger'">
                    {{ data[indextr].is_active ? 'Active' : 'De-Active' }}
                  </vs-td>


                  <vs-td v-can="'create-edit-site'">
                    <div class="vx-row">
                      <vx-tooltip text="View/Update" position="top" class="mr-2">
                        <vs-button @click.stop="onClickCustomerSiteUpdate(data[indextr].id)"
                                   size="small" color="warning" type="border" icon-pack="feather" icon="icon-edit"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip :text="tr.is_active ? 'De-Activate Site' : 'Activate Site'" position="top">
                        <vs-button @click.stop="onClickCustomerSiteStatusChange(data[indextr].id)"
                                   size="small" :color="tr.is_active ? 'danger' : 'primary'" 
                                   type="border" icon-pack="feather" :icon="tr.is_active ? 'icon-x' : 'icon-check-square'"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip text="Delete Site" position="top" class="ml-2" v-can="'delete-site'">
                        <vs-button @click.stop="openDeleteConfirm(data[indextr].id)"
                                   size="small" color="danger" type="border" icon-pack="feather" icon="icon-trash-2"></vs-button>
                      </vx-tooltip>
                    </div>
                  </vs-td>
                </vs-tr>
              </template>


            </vs-table>
            <vs-pagination v-can="'view-site'" :total="(meta.last_page)? meta.last_page : 0" v-model="page"  class="p-5"></vs-pagination>

          </div>
        </vx-card>
      </div>
    </div>
    <create-customer-site-pop-up ref="createCustomerSitePopUp" />
    <update-customer-site-pop-up ref="updateCustomerSitePopUp"/>
  </div>
</template>

<script>
  import vSelect from 'vue-select'
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  import Filter from '@/mixins/filter';
  const CustomerRepository = RepositoryFactory.get('customer')
  import CreateCustomerSitePopUp from '@/components/popups/customer/sites/CreateCustomerSitePopUp'
  import UpdateCustomerSitePopUp from '@/components/popups/customer/sites/UpdateCustomerSitePopUp'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  export default {
    name: 'AllUsersList',
    data () {
      return {
        staff: [],
        filters: {},
        page : 1,
        total: 0,
        meta : {},
        sort : '',
        customerId: ''
      }
    },
    components: {
      'v-select': vSelect,
      CreateCustomerSitePopUp,
      UpdateCustomerSitePopUp
    },
    mixins : [Filter, SuccessMessage, ErrorMessages],
    async mounted () {
      this.customerId = this.$route.params.id
      // this.$router.push({path: `/pages/manage-nimble/customers/${this.supplierId}?step=2`})
    },
    methods: {
      async refreshData () {
        this.fetchCustomerSiteList()
      },

      async fetchCustomerSiteList() {
        await this.$vs.loading({
          container: '#customer-site-list-table',
          scale: 0.45
        })
        try {
          const {data} = await CustomerRepository.getCustomerSites(this.customerId, this.page, this.filterQuery, 10, this.sort)
          this.staff =  data.data
          this.meta = data.meta
        } catch (error) {
          
        }
        this.$vs.loading.close('#customer-site-list-table > .con-vs-loading')
      },

      async onClickCreateSite () {
        await this.$refs.createCustomerSitePopUp.openPopup(this.customerId)
      },
      async onClickCustomerSiteUpdate (id) {
        await this.$refs.updateCustomerSitePopUp.openPopup(id, this.customerId)
      },
      async onClickCustomerSiteStatusChange(id) {
        await this.$vs.loading({
          container: '#customer-site-list-table',
          scale: 0.45
        })
        try {
          await CustomerRepository.customerSiteStatusChange(id)
          await this.fetchCustomerSiteList()
        } catch (error) {
          
        }
        this.$vs.loading.close('#customer-site-list-table > .con-vs-loading')
      },
      openDeleteConfirm (id) {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: 'Confirm',
          text: 'Are you sure you want to delete this customer site?',
          accept: this.deleteCustomerSite,
          acceptText: 'Confirm',
          parameters: [id]
        })
      },
      async deleteCustomerSite (params) {
        const id = Array.isArray(params) ? params[0] : params
        await this.$vs.loading({
          container: '#customer-site-list-table',
          scale: 0.45
        })
        try {
          await CustomerRepository.deleteCustomerSite(id)
          this.showSuccessMessage('Customer site deleted successfully!')
          await this.fetchCustomerSiteList()
        } catch (error) {
          this.convertAndNotifyError(error)
        }
        this.$vs.loading.close('#customer-site-list-table > .con-vs-loading')
      },
      filterQueryUpdate (){
        this.fetchCustomerSiteList()
      },

      handleChangePage(page) {
        this.page=page;
        this.fetchCustomerSiteList()
      }

    },
    watch : {
      page(){
        this.fetchCustomerSiteList()
      }
    }
  }
</script>


<style scoped>
  .user-edit-popup  >>> .vs-popup  {
    min-height: 50% !important;
    min-width: 50% !important;
  }

  @media (min-width: 768px) and (max-width: 1319px) {
    .user-edit-popup  >>> .vs-popup {
      min-height: 50% !important;
      min-width: 65% !important;
    }
  }
</style>
